
import React from "react";
import OtpInput from "react-otp-input";
import {
    Button,
    FlexColumn,
    SeparatorLine,
    SushiModal,
    WhiteWrapper,
} from "../../Common/styles.common";
import { Loader } from "../../Common/Loader";
import DDPoHeader from "../../Header/DDPoHeader";
import styles from "../../Login/Login.module.scss";
import { errorDisp } from "../../Login/styles.login";

// ─── Mobile elements (DO NOT MODIFY) ─────────────────────────────────────────

export const DDPodFormOtpSection = ({
    otp,
    setOtp,
    showError,
    errorText,
    makeValidateOtp,
    openConfirmation,
    closeConfirmation,
}) => (
    <div>
        <div className="d-flex flex-column po-content">
            <WhiteWrapper className="invoice-form ml-2 mr-2 mt-1">
                <div className="d-flex flex-column mr-4 ml-1">
                    <span className="fs-18 fw-700">Enter verification code</span>
                    <span className="fs-12 fw-400 text-gray-cool mt-1 mb-4">
                        shared by customer during delivery
                    </span>
                </div>
                <OtpInput
                    inputType="number"
                    containerStyle={`${styles.otpInputField} mb-3`}
                    value={otp}
                    onChange={(val) => setOtp(val)}
                    numInputs={6}
                    renderSeperator={"-"}
                    renderInput={(a) => <input {...a} />}
                />
                {showError ? (
                    <errorDisp className="fs-12 text-red-700">
                        {errorText || "Wrong OTP Entered"}
                    </errorDisp>
                ) : (
                    <></>
                )}
            </WhiteWrapper>
        </div>
        <WhiteWrapper className="po-bottom">
            <Button className="fs-13 text-white fw-600" onClick={makeValidateOtp}>
                Mark delivered
            </Button>
        </WhiteWrapper>
        <SushiModal visible={openConfirmation} isCentered>
            <FlexColumn className="align-items-center p-5">
                <img src="/logos/tick_logo.svg" height="80px" width="80px" />
                <span className="fs-22 fw-700 my-4">Order delivered</span>
                <span className="fs-14 fw-500 text-red-500" onClick={closeConfirmation}>
                    {" "}
                    Okay
                </span>
            </FlexColumn>
        </SushiModal>
    </div>
);

export const DDPodFormImageUploadSection = ({
    imageArray,
    previewImage,
    handleImageInputChange,
    errorMsg,
    fileTypeErr,
    navigateToOtpPage,
    uploadTitle = "Upload delivery challan",
}) => (
    <div>
        <div className="d-flex flex-column po-content">
            <WhiteWrapper className="invoice-form ml-2 mr-2 mt-1">
                <div className="d-flex flex-column mr-4 ml-1">
                    <span className="fs-18 fw-700">{uploadTitle}</span>
                    <span className="fs-12 fw-400 text-gray-cool mt-1">
                        with signature and issue
                    </span>
                    <span className="fs-9 fw-400 text-gray-cool mt-1">
                        (supported file types are .jpeg, .jpg, .png and .tiff)
                    </span>
                </div>
                <SeparatorLine />
                <div className="d-flex flex-wrap">
                    {imageArray.map((box, index) => (
                        <div key={index}>
                            <div className="box ml-2 mt-1">
                                {previewImage.length > index ? (
                                    <img
                                        className="image-preview"
                                        src={previewImage[index]}
                                        alt={`Image-${index}`}
                                        id={`Image-icon-${index}`}
                                    />
                                ) : (
                                    <div className="d-flex flex-column">
                                        <input
                                            src={"/logos/camera_add.svg"}
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleImageInputChange(e)}
                                            style={{ display: "none" }}
                                            id={`imageInput-${index}`}
                                        />
                                        <label htmlFor={`imageInput-${index}`}>
                                            <img
                                                className="icon"
                                                src={"/logos/camera_add.svg"}
                                                width="25px"
                                                height="25px"
                                                alt="Upload Image"
                                                id={`Image-icon-${index}`}
                                            />
                                        </label>
                                        <span className="fs-10 fw-400 text-red-500">{`Page ${index + 1}`}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                {errorMsg ? (
                    <errorDisp className="fs-12 text-red-700">
                        Please add delivery challan
                    </errorDisp>
                ) : fileTypeErr ? (
                    <errorDisp className="fs-12 text-red-700">
                        Please upload images with correct file type
                    </errorDisp>
                ) : (
                    <></>
                )}
            </WhiteWrapper>
        </div>
        <WhiteWrapper className="po-bottom">
            <Button className="fs-13 text-white fw-600" onClick={navigateToOtpPage}>
                Verify with OTP
            </Button>
        </WhiteWrapper>
    </div>
);

export const DDPodFormHeader = ({ po, items, tonnage }) => (
    <DDPoHeader
        poId={po.id}
        purchaseOrderNumber={po.purchase_order_number}
        itemsLength={items.length}
        tonnage={tonnage}
        source="podForm"
    />
);

// ─── Desktop elements ─────────────────────────────────────────────────────────
// NOTE: CTA buttons and modals have been moved to the desktop page components.
// These elements render only the card *content* (no po-header / po-content /
// po-bottom classes, no embedded Button, no embedded SushiModal).

/**
 * Desktop OTP card content.
 * Renders OTP input + inline error.
 * The "Mark delivered" button and confirmation SushiModal are owned by the
 * parent desktop page component (DDPodFormDesktop / DDPodFormV2Desktop).
 */
export const DDPodFormDesktopOtpSection = ({
    otp,
    setOtp,
    showError,
    errorText,
}) => (
    <div style={{ display: "flex", flexDirection: "column" }}>
        <span className="fs-18 fw-700">Enter verification code</span>
        <span className="fs-12 fw-400 text-gray-cool" style={{ marginTop: 4, marginBottom: 20 }}>
            shared by customer during delivery
        </span>
        <OtpInput
            inputType="number"
            containerStyle={`${styles.otpInputField} mb-3`}
            value={otp}
            onChange={(val) => setOtp(val)}
            numInputs={6}
            renderSeperator={"-"}
            renderInput={(a) => <input {...a} />}
        />
        {showError ? (
            <errorDisp className="fs-12 text-red-700 mb-3">
                {errorText || "Wrong OTP Entered"}
            </errorDisp>
        ) : (
            <div style={{ marginBottom: 12 }} />
        )}
    </div>
);

/**
 * Desktop image-upload card content.
 * Renders the image boxes + status messages only.
 * The "Verify with OTP" button is owned by the parent desktop page component.
 * Image boxes are 120×120 px (desktop size).
 */
export const DDPodFormDesktopImageUploadSection = ({
    imageArray,
    previewImage,
    handleImageInputChange,
    errorMsg,
    fileTypeErr,
}) => (
    <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
            {imageArray.map((box, index) => (
                <div
                    key={index}
                    style={{
                        width: 120,
                        height: 120,
                        border: "1px dashed #d0d0d0",
                        borderRadius: 8,
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#fafafa",
                    }}
                >
                    {previewImage.length > index ? (
                        <img
                            className="image-preview"
                            src={previewImage[index]}
                            alt={`Image-${index}`}
                            id={`Image-icon-desktop-${index}`}
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                    ) : (
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleImageInputChange(e)}
                                style={{ display: "none" }}
                                id={`imageInput-desktop-${index}`}
                            />
                            <label
                                htmlFor={`imageInput-desktop-${index}`}
                                style={{ cursor: "pointer", marginBottom: 4 }}
                            >
                                <img
                                    className="icon"
                                    src={"/logos/camera_add.svg"}
                                    width="32px"
                                    height="32px"
                                    alt="Upload Image"
                                    id={`Image-icon-desktop-${index}`}
                                />
                            </label>
                            <span className="fs-10 fw-400 text-red-500">
                                {`Page ${index + 1}`}
                            </span>
                        </div>
                    )}
                </div>
            ))}
        </div>
        {errorMsg ? (
            <errorDisp className="fs-12 text-red-700" style={{ marginTop: 12 }}>
                Please add delivery challan
            </errorDisp>
        ) : fileTypeErr ? (
            <errorDisp className="fs-12 text-red-700" style={{ marginTop: 12 }}>
                Please upload images with correct file type
            </errorDisp>
        ) : (
            <div style={{ marginBottom: 16 }} />
        )}
    </div>
);
